import TransactionsModalsWithdrawFormContent from './Content';
import TransactionsModalWithdrawContentFormLayout from './Layout';

/**
 * TransactionModalsWithdrawContentTransactionForm Component
 * This component is responsible for rendering the form layout and content for the withdrawal process.
 *
 * @returns {JSX.Element} The form layout component containing the form content component.
 *
 * @example
 * // This component does not take any parameters and returns:
 * <TransactionsModalWithdrawContentFormLayout>
 *   <TransactionsModalsWithdrawFormContent />
 * </TransactionsModalWithdrawContentFormLayout>
 */
export default function TransactionModalsWithdrawContentTransactionForm() {
  return (
    <TransactionsModalWithdrawContentFormLayout>
      <TransactionsModalsWithdrawFormContent />
    </TransactionsModalWithdrawContentFormLayout>
  );
}
